import {defineStore} from 'pinia';
import { useStorage } from '@vueuse/core';

import { HistoryEvent } from "@/sdk";

export interface DiscountDef {
        name: string,
        description: string,
        credits: number,
        sku: string,
        unit_amount: StorePrice,
        quantity: number,
    }

export interface StorePrice {
        currency_code: string,
        value: string,
}


// export interface StoreItem {
//     name: string,
//     description: string,
//     credits: number,
//     discount: number,
//     sku: string,
//     unit_amount: StorePrice,
//     quantity: number,
// }


const discountDefs = [
    {
        name: "1",
        description: "1 Single Credits",
        sku: "Memory-Tree-1",
        credits: 1,
        unit_amount: {
            currency_code: "USD",
            value: "4.00",
        } as StorePrice,
    } as DiscountDef,
    {
        name: "10",
        description: "10 Credit Pack",
        sku: "Memory-Tree-10",
        credits: 10,
        unit_amount: {
            currency_code: "USD",
            value: "3.00",
        } as StorePrice,
    } as DiscountDef,
    {
        name: "25",
        description: "25 Credit Pack",
        sku: "Memory-Tree-25",
        credits: 25,
        unit_amount: {
            currency_code: "USD",
            value: "2.75",
        } as StorePrice,
    } as DiscountDef,
    {
        name: "50",
        description: "50 Credit Pack",
        sku: "Memory-Tree-50",
        credits: 50,
        unit_amount: {
            currency_code: "USD",
            value: "2.50",
        } as StorePrice,
    } as DiscountDef,
    {
        name: "100",
        description: "100 Credit Pack",
        sku: "Memory-Tree-100",
        credits: 100,
        unit_amount: {
            currency_code: "USD",
            value: "2.00",
        } as StorePrice,
    } as DiscountDef,
    {
        name: "250",
        description: "250 Credit Pack",
        sku: "Memory-Tree-250",
        credits: 250,
        unit_amount: {
            currency_code: "USD",
            value: "2.00",
        } as StorePrice,
    } as DiscountDef,
    {
        name: "500",
        description: "500 Credit Pack",
        sku: "Memory-Tree-500",
        credits: 500,
        unit_amount: {
            currency_code: "USD",
            value: "2.00",
        } as StorePrice,
    } as DiscountDef,
    {
        name: "1000",
        description: "1000 Credit Pack",
        sku: "Memory-Tree-1000",
        credits: 1000,
        unit_amount: {
            currency_code: "USD",
            value: "2.00",
        } as StorePrice,
    }
] as DiscountDef[];


export const useTokenStore = defineStore('tokens', {
    state: () => {
        return { 
            loading: true,
            cart: useStorage('cart', 0),
            discounts: useStorage('discounts', discountDefs),
            }
    },
    actions: {
        clear() {
            this.cart = 0;    
        },
        resetStore() {
            this.clear();
            this.cart = 0;
            //this.$reset();
        },
    },
    getters: {        
        // totalCartCredits: (state) => state.items.reduce((previousValue: number, itemB: StoreItem) => { 
        //     return previousValue + (itemB.credits * itemB.quantity);
        // }, 0),
        totalCartCredits: (state) => state.cart,
        // totalItems: (state) => {
        //     let total = 0;
        //     for (let iTotal = 0; iTotal < state.items.length; iTotal++) {
        //       total = total + state.items[iTotal].quantity;
        //     }
        //     return total;
        //   }
        totalItems: (state) => state.cart,
        activeDiscount: (state) => state.discounts.slice().reverse().find((discount) => state.cart >= discount.credits)

    }
});

